class ChatWrapper {
    constructor(connectionManager, config) {
        this.connectionManager = connectionManager;
        this.config = config;
        this.pubSub = new PubSub();
        this.isAdded = false;
    }

    add(chatState, gameName) {
        if (!this.isAdded) {
            this.isAdded = true;
            this.chatLanguage = new ChatLanguage(this.config.locale);
            this.CegoXMPP = new ChatClient(this.pubSub, this.connectionManager, this.chatLanguage, this.config, this);
            this.CegoXMPP.INIT_ROOM = gameName;
            if (app.storage.get(this.CegoXMPP.INIT_ROOM + ":chat:hide:" + app.config.user.id) === "true" || screen.width < 700) {
                this.hideChat();
            } else {
                this.openChat();
            }
            this.CegoXMPP.user = this.config.user;
            this.CegoXMPP.moderators = this.config.moderators;
            this.CegoXMPP.staff = this.config.staff;
            this.connectionManager.addListener(this.CegoXMPP);
            this.CegoXMPP.Timer = new CegoXMPPTimer();
            this.CegoXMPP.Time = new CegoXMPPTime();
            this.CegoXMPP.Users = new CegoXMPPUsers(gameName, this.CegoXMPP);
            this.CegoXMPP.WordFilter = new CegoXMPPWordFilter();
            this.CegoXMPP.Emoticons = new Emoticons(this.CegoXMPP);
            this.CegoXMPP.UserSettings = new CegoXMPPUserSettings(this.CegoXMPP);
            this.CegoXMPP.DirectChat = new DirectChat(this.CegoXMPP);
            this.CegoXMPP.init(chatState, gameName);
        }
    }

    initiateDirectChat(username) {
        document.querySelector('#instantMessages .dropdown-toggle').click();
        this.CegoXMPP.DirectChat.beginDirectChat(username);
    }

    hideChat(doSet = true) {
        this.CegoXMPP.IS_AVAILABLE = false;
        if (doSet) {
            app.storage.set(this.CegoXMPP.INIT_ROOM + ":chat:hide:" + app.config.user.id, true);
        }
        let playGameWrapper = document.querySelector('.playgame-wrapper');
        if (playGameWrapper) {
            playGameWrapper.classList.add('chat-hidden');
        }
    }

    toggleChat() {
        let playGameWrapper = document.querySelector('.playgame-wrapper');
        if (playGameWrapper.classList.contains("chat-hidden")) {
            this.openChat();
        } else {
            this.removeChat(true);
        }
    }

    openChat() {
        let playGameWrapper = document.querySelector('.playgame-wrapper');
        if (playGameWrapper) {
            playGameWrapper.classList.remove('chat-hidden');
        }
        this.CegoXMPP.joinRoom(this.CegoXMPP.ROOMNAME);
        this.CegoXMPP.IS_AVAILABLE = true;
        if (this.CegoXMPP.INIT_ROOM) {
            app.storage.remove(this.CegoXMPP.INIT_ROOM + ":chat:hide:" + app.config.user.id);
        } else {
            app.storage.remove("none:chat:hide:" + app.config.user.id);
        }
        if (document.getElementById("chat-wrapper")) {
            if (!window.adOverlayInterval) {
                window.adOverlayInterval = setInterval(function () {
                    app.analytics.insertOverlayAd("#chat-wrapper", 20, "game_side_top");
                }, 600000);
            }
            setTimeout(function () {
                app.analytics.insertOverlayAd("#chat-wrapper", 20, "game_side_top");
            }, 180000);
        }
    }

    removeChat(doSet = false) {
        let playGameWrapper = document.querySelector('.playgame-wrapper');
        if (playGameWrapper) {
            playGameWrapper.classList.add('chat-hidden');
        }
        this.CegoXMPP.IS_AVAILABLE = false;
        this.CegoXMPP.leaveRoom(this.CegoXMPP.CURRENT_ROOM, true);
        if (doSet) {
            app.storage.set(this.CegoXMPP.INIT_ROOM + ":chat:hide:" + app.config.user.id, true);
        }
    }
}